import { render, staticRenderFns } from "./CbsCollapse.vue?vue&type=template&id=0645950e&scoped=true"
import script from "./CbsCollapse.vue?vue&type=script&lang=js"
export * from "./CbsCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645950e",
  null
  
)

export default component.exports